import React, { Component } from 'react';
import $ from 'jquery';

class AddressModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async () => {
        const { cleanData } = this.props;
        $('#addressModal').modal('hide');
        await cleanData();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#addressModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };


    OnChangeStreet = async (value) => {
        const { address, refreshAddress } = this.props;
        address.Street = value;
        await refreshAddress(address);
    }

    OnChangeBlock = async (value) => {
        const { address, refreshAddress } = this.props;
        address.Block = value;
        await refreshAddress(address);
    }

    OnChangeCity = async (value) => {
        const { address, refreshAddress } = this.props;
        address.City = value;
        await refreshAddress(address);
    }

    OnChangeZipCode = async (value) => {
        const { address, refreshAddress } = this.props;
        address.ZipCode = value;
        await refreshAddress(address);
    }

    OnChangeCounty = async (value) => {
        const { address, refreshAddress } = this.props;
        address.County = value;
        await refreshAddress(address);
    }

    OnChangeCountry = async (value) => {
        const { address, refreshAddress } = this.props;
        address.Country = value;
        await refreshAddress(address);
    }

    OnChangeState = async (value) => {
        const { address, refreshAddress } = this.props;
        address.State = value;
        await refreshAddress(address);
    }

    SaveChanges = async () => {
        const { aceptEditAddress, address } = this.props;
        await aceptEditAddress(address);
    }

    render() {
        const { address } = this.props;
        return (
            <div className="modal" tabIndex="-1" role="dialog" data-backdrop="false" id="addressModal" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ID Dirección</span>
                                    </div>
                                    <input type=" text" className="form-control input-sm"
                                        disabled="true"
                                        value={address.Address || ""}
                                        onChange={(event) => { this.OnChangeAddress(event.target.value) }}
                                    />
                                </div>

                                {/*Street*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calle/Número</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.Street || ""}
                                        onChange={(event) => { this.OnChangeStreet(event.target.value) }}
                                        id="txtTel2" />
                                </div>

                                {/*Block*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Colonia</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.Block || ""}
                                        onChange={(event) => { this.OnChangeBlock(event.target.value) }}
                                        id="txtTel2" />
                                </div>

                                {/*City*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Ciudad</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.City || ""}
                                        onChange={(event) => { this.OnChangeCity(event.target.value) }}
                                        id="txtTel2" />
                                </div>


                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Código Postal</span>
                                    </div>
                                    <input type="number" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.ZipCode || ""}
                                        onChange={(event) => { this.OnChangeZipCode(event.target.value) }}
                                        id="txtTel2"
                                        pattern="[0-9]+" />
                                </div>

                                {/*County*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Condado</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.County || ""}
                                        onChange={(event) => { this.OnChangeCounty(event.target.value) }}
                                        id="txtTel2" />
                                </div>

                                {/*Pais*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">País</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.Country || ""}
                                        onChange={(event) => { this.OnChangeCountry(event.target.value) }}
                                        id="txtTel2" />

                                    {/* <button
                                                type="button"
                                                style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                className="input-group-text"
                                                
                                                // onClick={() => this.openCountry('invoices')}
                                                >
                                                <i className="fa fa-list" aria-hidden="true"/>
                                            </button> */}

                                </div>

                                {/*State*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        value={address.State || ""}
                                        onChange={(event) => { this.OnChangeState(event.target.value) }}
                                        id="txtTel2" />

                                    {/* <button
                                                type="button"
                                                style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                className="input-group-text"
                                                // onClick={() => this.openState('invoices')}
                                                >
                                                <i className="fa fa-list" aria-hidden="true"/>
                                            </button> */}
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect text-black" onClick={() => { this.closeConfirm() }}>Cancelar</button>
                            <button type="button" className="btn botonCerrar text-white" onClick={() => { this.SaveChanges() }}>Actualizar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default AddressModal;